// extracted by mini-css-extract-plugin
export default {"tooltip":"YrCZzxIM","alignCenter":"GOWudQ5t","alignRight":"A95mqGzj","alignLeft":"xpaVz2zF"};